import React from 'react';
import { Text, Button } from '@radix-ui/themes';
import caseStudy from "../../../assets/images/caseStudy.png";

interface PresentationRankOrderProps {
  showButton: boolean;
  onPress: () => void;
  groupName: string;
  presentationRank: any;
}

const PresentationRankOrder: React.FC<PresentationRankOrderProps> = ({ showButton, onPress, groupName, presentationRank }) => {
  return (
    <div className="flex flex-col justify-center items-center h-full relative">
      {/* <div className="absolute top-0 w-full flex justify-center z-50">
        <div className="bg-[rgba(33,32,37,0.8)] w-[55vw] rounded-lg py-2 px-4 border border-[rgba(84,84,85,1)] flex items-center justify-center">
          <Text className="text-[#E9BE50] font-bold text-xs">
            Case Discussion & Presentation in progress
          </Text>
          <div className="w-3" />
          <div className="h-3 w-3 rounded-full bg-green-600 border border-[#E9BE50]" />
        </div>
      </div> */}
      <div className="w-full flex justify-center">
        <div className="bg-[#24272C] relative w-[30rem] largescreen:h-64 max-w-[536px] mobile:max-w-[90%] mobile:w-80  mobile:h-48 tablet:h-64 laptop:h-72 desktop:h-72 bg-gray-800 rounded-2xl flex flex-col items-center justify-center shadow-lg">
          {/* SVG at top-left */}
          <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none" className="absolute top-2 left-2 mobile:w-[40px] mobile:h-[40px] tablet:w-[40px] tablet:h-[40px] laptop:w-[50px] laptop:h-[50px] desktop:w-[57px] desktop:h-[57px]">
            <mask id="mask0_6083_19462" maskUnits="userSpaceOnUse" x="0" y="0" width="72" height="72">
              <rect width="72" height="72" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6083_19462)">
              <path d="M63 63V15H9V39H3V15C3 13.35 3.5875 11.9375 4.7625 10.7625C5.9375 9.5875 7.35 9 9 9H63C64.65 9 66.0625 9.5875 67.2375 10.7625C68.4125 11.9375 69 13.35 69 15V57C69 58.65 68.4125 60.0625 67.2375 61.2375C66.0625 62.4125 64.65 63 63 63ZM27 42C23.7 42 20.875 40.825 18.525 38.475C16.175 36.125 15 33.3 15 30C15 26.7 16.175 23.875 18.525 21.525C20.875 19.175 23.7 18 27 18C30.3 18 33.125 19.175 35.475 21.525C37.825 23.875 39 26.7 39 30C39 33.3 37.825 36.125 35.475 38.475C33.125 40.825 30.3 42 27 42ZM27 36C28.65 36 30.0625 35.4125 31.2375 34.2375C32.4125 33.0625 33 31.65 33 30C33 28.35 32.4125 26.9375 31.2375 25.7625C30.0625 24.5875 28.65 24 27 24C25.35 24 23.9375 24.5875 22.7625 25.7625C21.5875 26.9375 21 28.35 21 30C21 31.65 21.5875 33.0625 22.7625 34.2375C23.9375 35.4125 25.35 36 27 36ZM3 66V57.6C3 55.9 3.4375 54.3375 4.3125 52.9125C5.1875 51.4875 6.35 50.4 7.8 49.65C10.9 48.1 14.05 46.9375 17.25 46.1625C20.45 45.3875 23.7 45 27 45C30.3 45 33.55 45.3875 36.75 46.1625C39.95 46.9375 43.1 48.1 46.2 49.65C47.65 50.4 48.8125 51.4875 49.6875 52.9125C50.5625 54.3375 51 55.9 51 57.6V66H3ZM9 60H45V57.6C45 57.05 44.8625 56.55 44.5875 56.1C44.3125 55.65 43.95 55.3 43.5 55.05C40.8 53.7 38.075 52.6875 35.325 52.0125C32.575 51.3375 29.8 51 27 51C24.2 51 21.425 51.3375 18.675 52.0125C15.925 52.6875 13.2 53.7 10.5 55.05C10.05 55.3 9.6875 55.65 9.4125 56.1C9.1375 56.55 9 57.05 9 57.6V60Z" fill="white" />
            </g>
          </svg>

          {/* Centered content */}
          <div className="mobile:p-3 mobile:mt-5 max-w-[300px] flex flex-col items-center justify-center space-y-2 mobile:space-y-1 tablet:space-y-2 laptop:space-y-3 desktop:space-y-4">
            <Text
              as="span"
              size="4"
              weight="bold"
              className="text-white text-[14px] font-[Lato-Bold] largescreen:text-[14px] text-center mobile:text-xs tablet:text-sm laptop:text-sm desktop:text-xl"
            >
              Your group {groupName} will present{'\n'}Order of presentation #{Number(presentationRank) + 1}
            </Text>
            <button
              onClick={onPress}
              className="bg-[#7056A1] py-2 px-4 rounded-lg mx-2 my-1 mobile:py-1 mobile:px-3 tablet:py-2 tablet:px-4 laptop:py-2 laptop:px-5 desktop:py-3 desktop:px-6"
            >
              <Text
                as="span"
                size="5"
                weight="bold"
                className="text-white font-[Lato-Bold] mobile:text-sm tablet:text-base laptop:text-lg desktop:text-xl"
              >
                ok
              </Text>
            </button>
            {/* <Text
                                        as="span"
                                        size="3"
                                        className="text-white text-[10px] font-[Lato-Italic] px-4 text-center mobile:text-xs tablet:text-sm laptop:text-base desktop:text-lg"
                                    >
                                        You will need to keep your camera and audio enabled for the best outcome & experience
                                    </Text> */}
          </div>
        </div>
      </div>
      {/* <div className="bg-[#F1F3FF] w-[80vw] rounded-2xl flex items-center justify-center flex-col">
        <div className="absolute -top-16 h-24 w-24 flex items-center justify-center rounded-full bg-[#E9BE50] border-2 border-white overflow-hidden">
          <img
            src={caseStudy}
            alt="Case Study"
            className="h-16 w-16 object-contain"
          />
        </div>

        <Text className="text-black py-4 text-center font-[Lato-Regular] text-base w-[60vw] mt-20 mb-4">
          Your {groupName} will present<br />Order of presentation #{Number(presentationRank) + 1}
        </Text>

        {showButton && (
          <Button
            onClick={onPress}
            className="bg-green-600 hover:bg-green-700 text-white font-[Lato-Regular] text-sm rounded-xl h-10 px-7 shadow-md mb-6"
          >
            OK
          </Button>
        )}
      </div> */}
    </div>
  );
};

export default PresentationRankOrder;